import React from "react";
import { motion } from "framer-motion";
import {
  PhoneCall,
  CalendarCheck2,
  Utensils
} from "lucide-react";
import "@fontsource/chivo";
import "@fontsource/dancing-script/400.css";
import img1 from "../1.webp";
import img2 from "../2.webp";
import img3 from "../3.webp";
import { Link } from "react-router-dom";


const services = [
  {
    title: "Contatti",
    icon: <PhoneCall size={48} />,
    button: "Contattaci",
    bg: img1,
    path: "/contatti",
  },
  {
    title: "Prenota",
    icon: <CalendarCheck2 size={48} />,
    button: "Prenota",
    bg: img2,
    path: "/prenota",
  },
  {
    title: "Snack-Bar",
    icon: <Utensils size={48} />,
    button: "Cooming Soon",
    bg: img3,
    path: "/", // adjust if you have a real route
  },
];


const Servizi = () => {
  return (
    <section className="w-full px-6 py-16 bg-white text-center">
      <h2 className="text-[#00B8C0] text-3xl sm:text-4xl md:text-5xl font-[chivo] mb-12">
        I nostri Servizi
      </h2>

      <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
        {services.map((service, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
            className="relative p-8 min-h-[380px] rounded-2xl overflow-hidden shadow-md hover:shadow-lg transition duration-300 flex flex-col items-center text-white"
                style={{
              backgroundImage: `url(${service.bg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            {/* Overlay */}
            <div className="absolute inset-0 bg-black/50 z-0 rounded-2xl" />

            {/* Content */}
            <div className="relative z-10 flex flex-col items-center justify-center h-full text-center space-y-6">
  <div className="text-[#F4C623]">{service.icon}</div>
  <h3 className="text-xl font-semibold font-[chivo]">{service.title}</h3>
  <Link to={service.path}>
  <button className="text-[18px] sm:text-[20px] md:text-[22px] px-6 sm:px-8 md:px-10 py-2 sm:py-3 border-2 border-white bg-transparent text-white rounded-full hover:bg-white hover:text-[#009FB7] transition duration-300 font-[chivo]">
    {service.button}
  </button>
</Link>

</div>

          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Servizi;
